// extracted by mini-css-extract-plugin
export default {"name":"TankSelectionPreview_name__8ZOFD","recirculation":"TankSelectionPreview_recirculation__2FAwF"};